var Backgrid = require('backgrid');
var PreSortHeaderCell = Backgrid.HeaderCell.extend({
  events: {
    mousedown: 'preSort',
    click: 'onClick'
  },

  preSort: function(e) {
    this.collection.trigger('presort:column', this.column);
  },

  onClick: function(e) {
    Backgrid.HeaderCell.prototype.onClick.call(this, e);
  },

  render: function() {
    Backgrid.HeaderCell.prototype.render.call(this);

    var width = this.column.get('width');
    if (width) {
      this.$el.css('width', width);
    }
    this.$el.addClass('custom-header-cell');

    return this;
  }
});

module.exports = PreSortHeaderCell;
